module.exports = "<script type=\"text/html\" id=\"questioneditor-propertygrid\">\n  <div role=\"tablist\">\n      <!-- ko if: $data.koHasObject -->\n          <!-- ko template: { name: $data.contentHtmlTemplate, data: $data.koElementEditor() } -->\n          <!-- /ko -->\n      <!-- /ko -->\n  </div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/questionEditors/questioneditor-propertygrid.html
// module id = 135
// module chunks = 0